module.exports = __webpack_public_path__ + "static/media/loading16.981623e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading16.png
// module id = 201
// module chunks = 0